var map = {
	"./anxiang/icon_discovery.png": "gTcs",
	"./default/icon_discovery.png": "zqci",
	"./huarong/icon_discovery.png": "a3Vu",
	"./master/icon_discovery.png": "jF9C",
	"./shaodong/icon_discovery.png": "gai7",
	"./taoyuan/icon_discovery.png": "PkAZ",
	"./yueyang/icon_discovery.png": "ZXua",
	"./zhuzhou/icon_discovery.png": "TiWQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vhah";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/icon_discovery\.png$
// module id = Vhah
// module chunks = 1